import React, { useContext } from "react";

import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { StructuredTextRenderer } from "../../components/StructuredTextRenderer";
import { Tagline } from "../../components/Tagline/Tagline";
import GeneralPageContext from "../../templates/GeneralPageContext";

import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import * as styles from "./component.module.less";

function Text({
    data: {
        anker,
        ctaButton,
        semanticOfHeadline,
        secundarButton,
        background,
        tagline,
        headline,
        subheadline,
        textSideBySide
    },
    type,
    hasLightBackground
}) {
    const {
        layout: { showAnchorNavigation }
    } = useContext(GeneralPageContext);
    return (
        <SectionContainer
            sectionId={anker}
            containerClass={gcs(
                styles.textContainer,
                [textSideBySide, styles.textSideBySide],
                [showAnchorNavigation, styles.anchored]
            )}
            background={background}
        >
            <div className={!textSideBySide ? "reducedWidth" : null}>
                <Tagline hasLightBackground={hasLightBackground}>
                    {tagline}
                </Tagline>
                <Headline
                    semanticOfHeadline={semanticOfHeadline}
                    hasLightBackground={hasLightBackground}
                >
                    {headline}
                </Headline>
            </div>

            <div className={!textSideBySide ? "reducedWidth" : null}>
                <StructuredTextRenderer
                    data={subheadline}
                    contentElementType={type}
                />

                <div className={styles.buttonContainer}>
                    <StructuredTextRenderer
                        data={ctaButton}
                        contentElementType={type}
                        itemLinkType="cta"
                    />

                    <StructuredTextRenderer
                        data={secundarButton}
                        contentElementType={type}
                        itemLinkType="primary"
                        itemLinkIcon="arrowRight"
                        itemLinkIconPosition="right"
                    />
                </div>
            </div>
        </SectionContainer>
    );
}

export { Text };
